import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Readmore extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Readmore',
    refs: ['btn', 'additionnalContent', 'btnLabel', 'btnLabel2'],
  };

  /**
   * On btn click
   * @returns {void}
   */
  onBtnClick() {
    this.$refs.additionnalContent.classList.toggle('hidden');
    this.open = !this.open;
    if (this.open) {
      this.$refs.btnLabel.classList.add('hidden');
      this.$refs.btnLabel2.classList.remove('hidden');
    } else {
      this.$refs.btnLabel.classList.remove('hidden');
      this.$refs.btnLabel2.classList.add('hidden');
    }
  }
}
